import { render, staticRenderFns } from "./UiSearchInput.vue?vue&type=template&id=dc4786ac&scoped=true&"
import script from "./UiSearchInput.vue?vue&type=script&lang=js&"
export * from "./UiSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./UiSearchInput.vue?vue&type=style&index=0&id=dc4786ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4786ac",
  null
  
)

export default component.exports